import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import AllowanceDetailActions from '../../../../reducers/modules/hr/allowance-detail/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'hr/allowance-detail'

export default class AllowanceDetailMiddleware {

  static create(params){
    return (dispatch) => {
      dispatch(AllowanceDetailActions.create());
    };
  }

  static update(params){
    return (dispatch) => {
      AllowanceDetailMiddleware.showOne(dispatch, params);
      dispatch(AllowanceDetailActions.update());
    };
  }
  static resetList(){
    return (dispatch) => {
        dispatch(AllowanceDetailActions.resetList());
      };
  }
  static list(params){
      return (dispatch) => {
          dispatch(AllowanceDetailActions.process());
          AllowanceDetailMiddleware.showlist(dispatch, params);
        };
  }
  static reset(){
    return (dispatch) => {
        dispatch(AllowanceDetailActions.reset());
      };
}
  static getOne(params){
    return (dispatch) => {
        dispatch(AllowanceDetailActions.view());
        AllowanceDetailMiddleware.showOne(dispatch, params);
      };
  }

  static beforeSaveNew(post,search){
    return (dispatch) => {
        dispatch(AllowanceDetailActions.submit());
        AllowanceDetailMiddleware.saveNew(dispatch, post,search);
      };
  }
  static beforeSaveUpdate(params,post,search){
    return (dispatch) => {
        dispatch(AllowanceDetailActions.submit());
        AllowanceDetailMiddleware.saveUpdate(dispatch, params, post,search);
      };
  }
  static beforeDelete(id,params){
    return (dispatch) => {
        dispatch(AllowanceDetailActions.delete());
        AllowanceDetailMiddleware.delete(dispatch,params,id);
      };
  }

  static getToken(){
      return cookieManager.getUserToken();
  }

  static getHelper(params=null){
    return (dispatch) => {
      AllowanceDetailMiddleware.showHelper(dispatch,params);
      };
  }

 
  static showHelper(dispatch,params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AllowanceDetailMiddleware.getToken()}`
        },
        url:process.env.REST_URL+'helper/get-helper-allowance-detail' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(AllowanceDetailActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        AllowanceDetailMiddleware.alertHendler(dispatch,error)
      });
  }

  static showlist(dispatch, params){
      axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${AllowanceDetailMiddleware.getToken()}`
          },
          url: url,
          responseType: 'json',
          params:params
        })
        .then((response) => {
          
          if (response && response.status === 200 && response.data) {
            dispatch(AllowanceDetailActions.list(response.data.result));
          }
        })
        .catch((error) => {
          AllowanceDetailMiddleware.alertHendler(dispatch,error)
        });
  }

  static showOne(dispatch, params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AllowanceDetailMiddleware.getToken()}`
        },
        url: url +'/'+params,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(AllowanceDetailActions.view(response.data.result));
        }
      })
      .catch((error) => {
        AllowanceDetailMiddleware.alertHendler(dispatch,error)
      });
  }

  static delete(dispatch, params,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AllowanceDetailMiddleware.getToken()}`
        },
        url: url +'/'+id,
        responseType: 'json'
      })
      .then((response) => {
       
        if (response && response.status === 200 && response.data) {
          MySwal.close()
          dispatch(AllowanceDetailActions.process(),AllowanceDetailMiddleware.showlist(dispatch, params));
          AllowanceDetailMiddleware.alertHendler(dispatch,response,true,'Delete Data Successfully','success')
        }
      })
      .catch((error) => {
        AllowanceDetailMiddleware.alertHendler(dispatch,error,true)
      });
  }

  static saveNew(dispatch, post,search){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AllowanceDetailMiddleware.getToken()}`
        },
        url: url,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(AllowanceDetailActions.process(),AllowanceDetailMiddleware.showlist(dispatch,search));
          dispatch(AllowanceDetailActions.success());
          AllowanceDetailMiddleware.alertHendler(dispatch,response,true,'Create Data Successfully','success')
        }
      })
      .catch((error) => {
        AllowanceDetailMiddleware.alertHendler(dispatch,error)
      });
  }

  static saveUpdate(dispatch, params, post, search){
    axios({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${AllowanceDetailMiddleware.getToken()}`
        },
        url: url+'/'+params,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(AllowanceDetailActions.process(),AllowanceDetailMiddleware.showlist(dispatch,search));
          dispatch(AllowanceDetailActions.success());
          AllowanceDetailMiddleware.alertHendler(dispatch,response,true,'Update Data Successfully','success')
        }
      })
      .catch((error) => {
        AllowanceDetailMiddleware.alertHendler(dispatch,error)
      });
  }

  static alertHendler(dispatch,result,isSwal=false,extraMessage='',type='error'){
    if(type=='error'){
      if (result.response) {
        const status=result.response.status
        switch(status){
          
          case 500:
            if(isSwal){
              const data=result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title:'Delete Error',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              })
            }else{
              const data=result.response.data
              dispatch(AllowanceDetailActions.error(data.error));
            }
          break;  
          case 403:
            console.log('Error 403');
          break;     
          case 404:
            console.log('Error 404');
          break;   
          case 401:
            const data=result.response.data
              MySwal.fire({
                title:'Login Invalid',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              }).then((result)=>{
                  if(result.isConfirmed){
                    <Navigate to="/login"></Navigate>
                  }
              })
          break;   
        }
      } else if (result.request) {
        MySwal.fire({
          title:'Internal Server Error',
          html:'Please info your Developer to fix this',
          icon:'error',
          showConfirmButton:true,
        })
        dispatch(AllowanceDetailActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
      }
    }else{
      MySwal.fire({
        title:'Success',
        html:extraMessage,
        icon:'success',
        showConfirmButton:true,
      })
    }
  }
}
